const menuTypes = {
    pause: "pause",
    death: "death",
    levelSelect: "levelSelect",
    levelCompletion: "levelCompletion"
}

export default menuTypes;